import { render, staticRenderFns } from "./TripCard.vue?vue&type=template&id=1a2a922f&scoped=true&"
import script from "./TripCard.vue?vue&type=script&lang=js&"
export * from "./TripCard.vue?vue&type=script&lang=js&"
import style0 from "./TripCard.vue?vue&type=style&index=0&id=1a2a922f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a922f",
  null
  
)

export default component.exports